import '.cc{position:relative;}.ssr-plugin'
import '.hx{width:64px;}.ssr-plugin'
import '.hy{height:64px;}.ssr-plugin'
import '.bv{flex-shrink:0;}.ssr-plugin'
import '.m{position:absolute;}.ssr-plugin'
import '.hz{bottom:-4px;}.ssr-plugin'
import '.dj{right:-4px;}.ssr-plugin'
import '.cy{border-radius:50%;}.ssr-plugin'
import '.i0{border:2px solid var(--shades-white);}.ssr-plugin'
import '.q{overflow:hidden;}.ssr-plugin'
import '.i1{width:32px;}.ssr-plugin'
import '.i2{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="cc hx hy bv"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="m hz dj cy i0 q i1 i2"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
